<template>
    <div class="material">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
                    <BreadcrumbItem>填报管理</BreadcrumbItem>
                    <BreadcrumbItem>会刊广告管理</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">会刊广告管理</div>
                <Input search placeholder="请输入关键字" v-model="search" @input="searchPro"
                    style="width:230px;margin-top:20px;" />
            </div>
            <div class="header-tool-box">
                <div @click="exportBnt()" class="htb-item">
                    <span >导出</span>
                </div>

            </div>
        </div>
        <div class="layout-content" style="background: transparent;">
            <div v-if="list.length">
                <el-table :data="list" style="width: 100%" row-key="id" :stripe="true"
                    :tree-props="{ children: 'childrens', hasChildren: 'hasChildren' }"
                    :header-cell-style="{ background: '#fafafa', color: '#333' }">
                    <el-table-column prop="exhibitor.exhibitorName" label="展商名称" align="center" />
                    <!-- <el-table-column prop="name" label="单位名称" align="center">
                        <template slot-scope="scope">
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="idCardNo" label="展位号" align="center" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.exhibitor&&scope.row.exhibitor.boothJson.indexOf('[')!=-1">
                                 <span v-for="(item,index) in JSON.parse(scope.row.exhibitor.boothJson)" :key="index">
                                  <span v-if="index!=0">,</span> {{ item.Code }}
                                </span>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="联系地址" align="center">
                    </el-table-column>
                    <el-table-column prop="postcode" label="邮编" align="center" />
                    <el-table-column prop="tel" label="电话" align="center" />
                    <el-table-column prop="contractName" label="联系人" align="center" />
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <div>
                                <el-button type="text" size="small" @click="goDetail(scope.row)">查看</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="page-container page_float">
                    <el-pagination hide-on-single-page background :current-page="page" :page-sizes="[10, 20, 30, 40]"
                        :page-size="size" layout="total,  prev, pager, next, sizes, jumper" :total="totalCount"
                        @size-change="changePageSize" @current-change="changePage" />
                </div>
            </div>
            <div class="u-empty" v-else>暂无数据</div>
        </div>



    </div>
</template>
  
<script>

import { mapGetters, mapActions } from "vuex";

export default {
    name: "host-ex-list",
    data () {
        return {
            page: 1,
            size: 10,

            list: [],
            search: '',
            search1: '',
            totalCount: 0,
        };
    },
    components: {

    },
    computed: {
        ...mapGetters({
            exhibition: "loginModule/getExhibitionId",
        }),
    },
    created () {
        this.init();
    },
    methods: {
        ...mapActions({
            journalAdvertRecordList: 'hostSetModuleG/journalAdvertRecordList', // 列表
            scheduleJobGql: 'hostSetModuleG/scheduleJobGql', // 导出
        }),

        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    resolve(valid);
                });
            });
        },
        goDetail (e) {
            // this.$router.push('/host/index/order/detail-order');
            this.$router.push(`/host/index/order/detail-order?id=${e.exhibitorId}&tab=6`);
        },
        async init () {
            let opt = {
                exhibitionId: this.exhibition,
                page: this.page,
                size: this.size,
                text: this.search
            }
            const res = await this.journalAdvertRecordList(opt);
            if (res) {
                this.list = res.items
                this.totalCount = res.totalCount

            }
        },
        async del (id) {
            const bool = await this.delCompanyById(id);
            if (bool && bool.successed) {
                this.$Message.success("删除成功");
                this.init();
            } else {
                this.$Message.error("删除失败，请重新尝试");
            }
        },
        searchPro () {
            console.log(this.search);
            this.search1= 'contractName.contains("' +
                    this.search +
                    '")'
            
            this.init()
        },
        changePage (e) {
            this.page = e
            this.init()
        },
        changePageSize (e) {
            this.size = e
            this.init()
        },


 //导出
       async exportBnt () {
            let opt = {
                taskCode: "JournalAdvertRecord.Export",
                name: "会刊广告管理导出",
                customTag: 'JournalAdvertRecord',
                argsJson: JSON.stringify({
                    exhibitionId: this.exhibition,
                    page: this.page,
                    size: this.size,
                    searching: this.search1
                }),
            }
            let res=await this.scheduleJobGql(opt) 
            if(res){
                this.$Message.success("导出成功");
                this.$router.push("/host/index/hostdate?customTag");
            }
        }

    },
};
</script>
  
<style scoped lang="scss">
.header-tool-utils {
    margin-top: 20px;

    button {
        margin-right: 20px;
    }
}

.logo {
    width: 60px;
    height: 60px;
    display: inline-block;
}

/deep/ .resetModal {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
        top: 0;
    }

    .ivu-modal-body {
        padding: 24px 0 0 16px;
    }
}
</style>
  
  